import React from 'react';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import { Select, SelectOption, Icons, SingleDatePicker, Button, FlexRow, FlexCol, TextField } from 'sarsaparilla';

const MANUAL_ENTRY = 'MANUAL_ENTRY';
export default class CommercialGuideItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleGuideSelect = this.handleGuideSelect.bind(this);
    this.handleGuideDateChange = this.handleGuideDateChange.bind(this);
    this.handleGuideInputDataChange = this.handleGuideInputDataChange.bind(this);
    this.state = {
      guide: props.guide,
      manualEntry: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ guide: nextProps.guide });
    if (!nextProps.guide.first_name && !nextProps.guide.last_name && !nextProps.guide.passholder_id) {
      this.setState({
        manualEntry: false
      });
      return;
    }

    if (!nextProps.allGuides.find((guide) => guide.passholder_id === nextProps.guide.passholder_id)) {
      this.setState({
        manualEntry: true
      });
    }
    else {
      this.setState({
        manualEntry: false
      });
    }
  }

  handleGuideSelect(event) {
    const guideId = event.target.value;
    if (guideId === MANUAL_ENTRY) {
      this.setState({ manualEntry: true });
      this.props.handleGuideChange(this.props.index, { passholder_id: " " });
      return;
    }
    const guide = this.props.allGuides.find((thisGuide) => thisGuide.license_number === guideId);
    const newGuide = { ...guide, passholder_id: guide.license_number, expiration_date: guide.license_expiration_date };
    this.props.handleGuideChange(this.props.index, newGuide);
  }

  handleGuideInputDataChange(event) {
    let guide = {};
    switch (event.target.id) {
      case 'guide-license-number':
        guide = Object.assign({}, this.state.guide, { passholder_id: event.target.value });
        this.setState({ guide });
        this.props.handleGuideChange(this.props.index, guide);
        break;
      case 'guide-first-name':
        guide = Object.assign({}, this.state.guide, { first_name: event.target.value });
        this.setState({ guide });
        this.props.handleGuideChange(this.props.index, guide);
        break;
      case 'guide-last-name':
        guide = Object.assign({}, this.state.guide, { last_name: event.target.value });
        this.setState({ guide });
        this.props.handleGuideChange(this.props.index, guide);
        break;
      default:
        break;
    }
  }

  handleGuideDateChange(date) {
    if (!date) return;
    const guide = Object.assign({}, this.state.guide, { expiration_date: date.utc().toJSON() });
    this.setState({ guide });
    this.props.handleGuideChange(this.props.index, guide);
  }

  isDisabled() {
    return this.props.isDisabled && this.props.index === 0;
  }

  renderGuideDropdown(guide) {
    const guideOpts = [
      <SelectOption key={MANUAL_ENTRY} value={MANUAL_ENTRY}>Manual Entry ...</SelectOption>,
      ...this.props.allGuides.map((g) => {
        return (
          <SelectOption key={g.license_number} value={g.license_number}>
            {g.first_name} {g.last_name}
          </SelectOption>
        );
      })
    ];
    return (
      <React.Fragment>
        <FlexCol sm={4} md={4} lg={6}>
          <Select
            id="guide-select"
            label="Employee/Guide"
            isLabelVisible={this.props.index === 0}
            placeholder="Select an option"
            value={guide.passholder_id}
            onChange={this.handleGuideSelect}
            isDisabled={this.isDisabled()}>
            {guideOpts}
          </Select>
        </FlexCol>
      </React.Fragment>
    );
  }

  renderManualEntryFields(guide) {
    return (
      <React.Fragment>
        <FlexCol sm={2} md={2} lg={3}>
            <TextField
              id="guide-first-name"
              label="Employee/Guide"
              isLabelVisible={this.props.index === 0}
              value={guide.first_name}
              placeholder="First Name"
              onChange={this.handleGuideInputDataChange} />
        </FlexCol>
        <FlexCol sm={2} md={2} lg={3}>
            <TextField
              id="guide-last-name"
              label="Employee/Guide"
              isLabelVisible={false}
              value={guide.last_name}
              className={this.props.index === 0 && 'mt-3 pt-half'}
              placeholder="Last Name"
              onChange={this.handleGuideInputDataChange} />
        </FlexCol>
      </React.Fragment>
    );
  }

  render() {
    const { guide } = this.state;

    return (
      <FlexRow className="mt-1">
        {(this.state.manualEntry) && this.renderManualEntryFields(guide)}
        {(!this.state.manualEntry) && this.renderGuideDropdown(guide)}
        <FlexCol sm={3} md={3} lg={2}>
          <TextField
            id="guide-license-number"
            label="Guide ID #"
            value={guide.passholder_id}
            onChange={this.handleGuideInputDataChange}
            isLabelVisible={this.props.index === 0} />
        </FlexCol>

        <FlexCol sm={3} md={3} lg={3}>
          {this.props.index === 0 && <label htmlFor="expiration-date"><b>Expiration Date</b></label>}
          <SingleDatePicker
            date={(guide.expiration_date) ? moment(guide.expiration_date).utc() : null}
            focused={this.state.focused}
            onFocusChange={({ focused }) => this.setState({ focused })}
            id="expiration-date"
            numberOfMonths={1}
            onDateChange={this.handleGuideDateChange} />
        </FlexCol>

        <FlexCol sm={1} md={1}>
          {!this.props.disableRemove &&
          <Button
            className={this.props.index === 0 ? "mt-4" : ''}
            appearance="link"
            onClick={this.props.handleGuideRemove}
            iconBeforeElement={<Icons.IconCloseCircle />} />}
        </FlexCol>
      </FlexRow>
    );
  }
}

CommercialGuideItem.propTypes = {
  handleGuideChange: PropTypes.func,
  handleGuideRemove: PropTypes.func,
  index: PropTypes.number,
  guide: PropTypes.shape({
    employee_id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    passholder_id: PropTypes.string,
    expiration_date: PropTypes.string,
    company_id: PropTypes.string
  }),
  allGuides: PropTypes.array,
  isDisabled: PropTypes.bool,
  disableRemove: PropTypes.bool
};

CommercialGuideItem.defaultProps = {
  isDisabled: false,
  disableRemove: false
};
